import call from './call';
import {push} from "connected-react-router";
import {CODES_ROUTE} from "../components/Root/routes";
import {UPDATE_DATA} from "../types";

const regenCodes= (formValues) => async (dispatch) =>
{
    const onResult= (result) =>
    {
        if(result && result[1].success)
        {
            dispatch({type:UPDATE_DATA,payload:result[1]});
            dispatch(push(CODES_ROUTE));
        }
    }
    dispatch(call("Service/regenCodes",formValues,onResult));
};
export default regenCodes;